import { Locale } from '../../../../modules/locale'
import { IFacetOption, IResult, MultipleResults } from '../../../../modules/search'
import { SearchTabItem } from './lvc-search-results-tabs'

const modalsWithFreeFilter = [
  'events_search',
  'exhibitions_search',
  'festivals_search',
  'eventseries_only',
]
const modalsWithHasEventsFilter = ['places_full', 'artists']

// TODO: Think about order?
export const compileSearchTabItems = (results: MultipleResults) => {
  return [
    {
      id: 'events',
      title: {
        fr: 'Événements',
        en: 'Events',
      },
      total: results?.['events_search']?.total,
      tabContent: renderSearchResultSection(
        results?.['events_search'],
        'events_search',
        modalsWithFreeFilter.includes('events_search'),
        modalsWithHasEventsFilter.includes('events_search')
      ),
      modalName: 'events_search',
    },
    {
      id: 'expositions',
      title: {
        fr: 'Expositions',
        en: 'Expositions',
      },
      total: results?.['exhibitions_search']?.total,
      tabContent: renderSearchResultSection(
        results?.['exhibitions_search'],
        'exhibitions_search',
        modalsWithFreeFilter.includes('exhibitions_search'),
        modalsWithHasEventsFilter.includes('exhibitions_search')
      ),
      modalName: 'exhibitions_search',
    },
    {
      id: 'festivals',
      title: {
        fr: 'Festivals',
        en: 'Festivals',
      },
      total: results?.['festivals_search']?.total,
      tabContent: renderSearchResultSection(
        results?.['festivals_search'],
        'festivals_search',
        modalsWithFreeFilter.includes('festivals_search'),
        modalsWithHasEventsFilter.includes('festivals_search')
      ),
      modalName: 'festivals_search',
    },
    {
      id: 'series',
      title: {
        fr: 'Séries',
        en: 'Series',
      },
      total: results?.['eventseries_only']?.total,
      tabContent: renderSearchResultSection(
        results?.['eventseries_only'],
        'eventseries_only',
        modalsWithFreeFilter.includes('eventseries_only'),
        modalsWithHasEventsFilter.includes('eventseries_only')
      ),
      modalName: 'eventseries_only',
    },

    {
      id: 'places',
      title: {
        fr: 'Lieux',
        en: 'Places',
      },
      total: results?.['places_full']?.total,
      tabContent: renderSearchResultSection(
        results?.['places_full'],
        'places_full',
        modalsWithFreeFilter.includes('places_full'),
        modalsWithHasEventsFilter.includes('places_full')
      ),
      modalName: 'places_full',
    },
    {
      id: 'artists',
      title: {
        fr: 'Artistes et Organisations',
        en: 'Artists and Organizations',
      },
      total: results?.['artists']?.total,
      tabContent: renderSearchResultSection(
        results?.['artists'],
        'artists',
        modalsWithFreeFilter.includes('artists'),
        modalsWithHasEventsFilter.includes('artists')
      ),
      modalName: 'artists',
    },
  ] as SearchTabItem[]
}
const renderSearchResultSection = (
  results: IResult,
  modalName: string,
  freeFilter = false,
  hasEventsFilter = false
) => {
  let items = results?.items
  if (['events_search'].includes(modalName)) {
    items = createSameDayEventList(items)
  }
  return /*html*/ `
    ${freeFilter ? `<lvc-free-search style="justify-content:start; padding:0 1rem;"></lvc-free-search>` : ''}
    ${hasEventsFilter ? `<lvc-has-events-search style="justify-content:start; padding:0 1rem;"></lvc-has-events-search>` : ''}
    ${
      results?.total > 0
        ? `
      <lvc-search-result-block style="margin-top:2rem;"
        results="${encodeURIComponent(JSON.stringify(items))}"
        data-modal="${modalName}"
        enable-date-blocks="${modalName === 'events_search' ? true : false}"
        data-component-location="recherche"
      >
    `
        : `<lvc-no-results data-is-search="true"></lvc-no-results>`
    }
  `
}
const createSameDayEventList = (events: any[]) => {
  if (!events) {
    return []
  }
  const groupedEvents = new Map()

  events.forEach(event => {
    // Use eventId and startDay as the unique key
    const key = `${event.eventId}-${event.startDay}`

    if (!groupedEvents.has(key)) {
      // If this is the first event with this eventId and startDay, add it to the map
      groupedEvents.set(key, { ...event, sameDayOffers: [] })
    } else {
      // If we already have this eventId and startDay, merge the current event into the sameAs array

      const existingEvent = groupedEvents.get(key)
      existingEvent.sameDayOffers.push(event)
    }
  })
  const groupedEventsArray = Array.from(groupedEvents.values())
  // Convert the map values back into an array of events
  return groupedEventsArray
}
